import React, { useEffect } from "react";

import { useAdminStudents } from "../../../store/admin";
import { formatDate } from "./userUtils";
import {
  DetailField,
  ModalOverlay,
  ModalHeader,
  ModalCloseButton,
} from "../common/Modal";

// ===== STUDENT DETAILS MODAL (GET /api/admin/students/:id) =====
const StudentDetailsModal = ({ isOpen, onClose, student }) => {
  const { studentDetail, studentDetailLoading, fetchStudent } = useAdminStudents();

  useEffect(() => {
    if (isOpen && student?.id) {
      fetchStudent(student.id);
    }
  }, [isOpen, student?.id, fetchStudent]);

  if (!isOpen || !student) return null;

  const detail = studentDetail || student;

  return (
    <ModalOverlay onClose={onClose} width="560px">
      <ModalHeader title="Student Details" onClose={onClose} />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "14px",
          marginBottom: "18px",
        }}
      >
        <div
          style={{
            width: "52px",
            height: "52px",
            borderRadius: "50%",
            background: "#eef2f7",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "22px",
            fontWeight: 600,
            color: "#64748b",
            flexShrink: 0,
          }}
        >
          {String(detail.name || "?")
            .split(" ")
            .map((n) => n[0] || "")
            .join("")
            .toUpperCase() || "?"}
        </div>
        <div>
          <div style={{ fontWeight: 600, fontSize: "16px", color: "#1e293b" }}>
            {detail.name || "--"}
          </div>
          <div style={{ fontSize: "13px", color: "#64748b" }}>
            {detail.email || "--"}
          </div>
        </div>
      </div>

      {studentDetailLoading && (
        <div
          style={{
            padding: "8px 0 14px",
            textAlign: "center",
            color: "#94a3b8",
            fontSize: "14px",
          }}
        >
          Loading latest details…
        </div>
      )}

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "14px" }}>
        <DetailField label="Phone Number" value={detail.phoneNumber || "—"} />
        <DetailField
          label="Status"
          value={detail.isActive ? "Active" : "Suspended"}
          valueColor={detail.isActive ? "#16a34a" : "#dc2626"}
        />
        <DetailField
          label="Email Verified"
          value={detail.emailVerified ? "Yes" : "No"}
          valueColor={detail.emailVerified ? "#16a34a" : "#dc2626"}
        />
        <DetailField
          label="Account Status"
          value={detail.accountStatus || detail.status || "--"}
        />
        <DetailField
          label="Date Joined"
          value={formatDate(detail.createdAt || detail.dateAdded)}
        />
        <DetailField
          label="Last Active"
          value={formatDate(detail.lastActive || detail.updatedAt)}
        />
      </div>

      {detail.qualification || detail.field || detail.field_of_study ? (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "14px",
            marginTop: "14px",
          }}
        >
          <DetailField label="Qualification" value={detail.qualification || "—"} />
          <DetailField
            label="Field of Study"
            value={detail.field_of_study || detail.field || "—"}
          />
        </div>
      ) : null}

      <ModalCloseButton onClose={onClose} />
    </ModalOverlay>
  );
};

export default StudentDetailsModal;